(function () {
  'use strict';

  const EXPRESS_SELECTORS = [
    '.shopify-payment-button',
    '.cart__dynamic-checkout-buttons',
    '#dynamic-checkout-cart',
    '[data-shopify="payment-button"]'
  ];

  const CHECKOUT_SELECTORS = [
    '[name="checkout"]',
    '#checkout',
    '.cart__checkout-button'
  ];

  const CART_FORM_SELECTORS = [
    'form[action="/cart"]',
    'form[action*="/cart"]',
    'form[action*="checkout"]'
  ];

  function hideExpressButtons() {
    EXPRESS_SELECTORS.forEach((selector) => {
      document.querySelectorAll(selector).forEach((element) => {
        element.style.setProperty('display', 'none', 'important');
      });
    });
  }

  function getAGBCheckboxes() {
    return Array.from(document.querySelectorAll('.agb-checkbox'));
  }

  function getAGBWrappers() {
    return Array.from(document.querySelectorAll('.agb-checkbox-wrapper'));
  }

  function isAGBChecked() {
    const checkboxes = getAGBCheckboxes();

    if (!checkboxes.length) {
      return true;
    }

    return checkboxes.some((checkbox) => checkbox.checked);
  }

  function setErrorState(active) {
    getAGBWrappers().forEach((wrapper) => {
      wrapper.classList.toggle('has-error', active);
    });
  }

  function scrollToFirstError() {
    const firstWrapper = document.querySelector('.agb-checkbox-wrapper.has-error');

    if (!firstWrapper) {
      return;
    }

    firstWrapper.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });

    const checkbox = firstWrapper.querySelector('.agb-checkbox');

    if (checkbox) {
      setTimeout(() => {
        checkbox.focus({ preventScroll: true });
      }, 250);
    }
  }

  function updateButtonVisuals() {
    const checked = isAGBChecked();

    document.querySelectorAll(CHECKOUT_SELECTORS.join(',')).forEach((button) => {
      button.style.opacity = checked ? '1' : '0.55';
      button.style.cursor = checked ? 'pointer' : 'not-allowed';
    });
  }

  function blockCheckout(event) {
    if (isAGBChecked()) {
      setErrorState(false);
      return true;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    setErrorState(true);
    updateButtonVisuals();
    scrollToFirstError();

    return false;
  }

  function bindCheckoutButtons() {
    document.querySelectorAll(CHECKOUT_SELECTORS.join(',')).forEach((button) => {
      if (button.dataset.agbClickBound === 'true') {
        return;
      }

      button.dataset.agbClickBound = 'true';

      button.addEventListener(
        'click',
        function (event) {
          blockCheckout(event);
        },
        true
      );
    });
  }

  function bindCartForms() {
    document.querySelectorAll(CART_FORM_SELECTORS.join(',')).forEach((form) => {
      if (form.dataset.agbSubmitBound === 'true') {
        return;
      }

      form.dataset.agbSubmitBound = 'true';

      form.addEventListener(
        'submit',
        function (event) {
          blockCheckout(event);
        },
        true
      );
    });
  }

  function bindCheckboxChanges() {
    if (document.documentElement.dataset.agbChangeBound === 'true') {
      return;
    }

    document.documentElement.dataset.agbChangeBound = 'true';

    document.addEventListener('change', function (event) {
      if (!event.target.classList.contains('agb-checkbox')) {
        return;
      }

      if (isAGBChecked()) {
        setErrorState(false);
      }

      updateButtonVisuals();
    });
  }

  function init() {
    hideExpressButtons();
    bindCheckoutButtons();
    bindCartForms();
    bindCheckboxChanges();
    updateButtonVisuals();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  const observer = new MutationObserver(() => {
    init();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  setTimeout(init, 800);
  setTimeout(init, 2000);
})();